import { QueryParser } from '../../app/shared/QueryParser';
import IProductLookupRedirectPageQuery from './IProductLookupRedirectPageQuery';
import { CODE, SKU } from './ProductLookupConsts';

export default class ProductLookupQueryParser extends QueryParser {
  static toModel(query: Map<string, string>): IProductLookupRedirectPageQuery {
    const sku = QueryParser.getValue(query, SKU);
    const code = QueryParser.getValue(query, CODE);

    return {
      sku: sku,
      code: code,
    };
  }

  static toQuery(queryModel: IProductLookupRedirectPageQuery) {
    const query = new Map<string, string>();

    if (queryModel.code) {
      QueryParser.setValue(query, CODE, queryModel.code);
    } else {
      QueryParser.setValue(query, SKU, queryModel.sku);
    }

    return query;
  }
}
